import { ConfigService } from './config.service';
import { environment } from '../../environments/environment';

export function configLoader(configService: ConfigService) {
    return () => configService.loadConfig(environment.configFile);
}
